"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "item" };
const _hoisted_2 = { class: "datas" };
const _hoisted_3 = { class: "top" };
const _hoisted_4 = { class: "buttons" };
const _hoisted_5 = { class: "decline" };
exports.default = (0, vue_1.defineComponent)({
    __name: 'ExcludedDayItem',
    props: {
        id: {
            type: Number,
            required: true,
        },
        date: {
            type: Date,
            required: true,
        },
    },
    emits: ["decline"],
    setup(__props, { emit }) {
        const decline = () => {
            emit("decline");
        };
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(__props.date), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createElementVNode)("button", _hoisted_5, [
                        (0, vue_2.createVNode)(_component_font_awesome_icon, {
                            class: "text-marso text-6xl",
                            icon: ['far', 'rectangle-xmark'],
                            onClick: decline
                        })
                    ])
                ])
            ]));
        };
    }
});
